module.exports = __webpack_public_path__ + "static/images/containers/WGCWXLeaderboards/components/Footer/images/ok.6bc1362f.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXLeaderboards/components/Footer/images/ok.png
// module id = 3454
// module chunks = 11